import * as v from 'valibot';

import { type Entities, optionSchema } from '@/modules/entities';

export const savedLocationApiSchema = v.object({
  addr1: v.string(),
  addr2: v.string(),
  city: v.string(),
  countryCode: v.string(),
  countryName: v.string(),
  customerKey: v.number(),
  id: v.number(),
  name: v.string(),
  searchId: v.string(),
  shipRecKey: v.number(),
  state: v.string(),
  stateName: v.string(),
  zip: v.string(),
});

export const savedLocationsApiSchema = v.array(savedLocationApiSchema);

export const savedLocationOptionSchema = v.object({
  ...optionSchema.entries,
  ...savedLocationApiSchema.entries,
  id: v.string(),
});

export type SavedLocationApi = v.InferOutput<typeof savedLocationApiSchema>;
export type SavedLocationsApi = v.InferOutput<typeof savedLocationsApiSchema>;
export type SavedLocationOption = v.InferOutput<typeof savedLocationOptionSchema>;
export type SavedLocations = Entities<SavedLocationOption>;

export type SavedLocationsFilters = {
  search?: {
    name?: string;
  };
};
